<template>
  <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
    <b-modal
      v-model="modalAberto"
      :title="title"
      header-bg-variant="secondary"
      header-text-variant="light"
      @hide="closeModal"
      centered
    >
      <b-form>
        <b-container>
          <b-row>
            <b-col cols="12">
              <default-form-validation-provider
                label="Descrição"
                rules="required"
                v-slot="defaultState"
              >
                <b-form-input
                  v-model="form.dsTipoAnexo"
                  :state="defaultState.state"
                  size="sm"
                  placeholder="Digite a descrição"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Grupo"
                rules="required"
                v-slot="defaultState"
              >
                <b-form-select
                  v-model="form.tpGrupoAnexo"
                  :state="defaultState.state"
                  size="sm"
                  :options="gruposSelect"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Ordem"
                rules=""
                v-slot="defaultState"
              >
                <b-form-input
                  v-model.number="form.nrOrdem"
                  :state="defaultState.state"
                  size="sm"
                  type="number"
                  min="0"
                  placeholder="Opcional"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider label="Tipo do Edital" rules="">
                <b-form-checkbox-group v-model="tiposEditalSelected" stacked>
                  <b-form-checkbox value="CON">Concurso</b-form-checkbox>
                  <b-form-checkbox value="PSS">Processo Seletivo Simplificado</b-form-checkbox>
                  <b-form-checkbox value="PSP">Processo Seletivo Público</b-form-checkbox>
                </b-form-checkbox-group>
                <small v-if="tiposEditalSelected.length === 0" class="text-danger">
                  Selecione pelo menos um tipo de edital.
                </small>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Início da Vigência"
                rules=""
                v-slot="defaultState"
              >
                <b-form-datepicker
                  v-model="form.dtInicioVigencia"
                  :state="defaultState.state"
                  locale="pt-BR"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  size="sm"
                  placeholder="Opcional"
                  reset-button
                  reset-button-variant="outline-secondary"
                  label-reset-button="Limpar"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Fim da Vigência"
                rules=""
                v-slot="defaultState"
              >
                <b-form-datepicker
                  v-model="form.dtFimVigencia"
                  :state="dtVigenciaInvalida ? false : defaultState.state"
                  locale="pt-BR"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  size="sm"
                  placeholder="Opcional"
                  reset-button
                  reset-button-variant="outline-secondary"
                  label-reset-button="Limpar"
                />
                <small v-if="dtVigenciaInvalida" class="text-danger">
                  A data final deve ser maior que a data inicial.
                </small>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6" class="mt-2">
              <default-form-validation-provider
                rules=""
                label=""
                v-slot="defaultState"
              >
                <b-form-checkbox
                  :state="defaultState.state"
                  v-model="form.flObrigatorio"
                >
                  Obrigatório
                </b-form-checkbox>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6" class="mt-2">
              <default-form-validation-provider
                rules=""
                label=""
                v-slot="defaultState"
              >
                <b-form-checkbox
                  :state="defaultState.state"
                  v-model="form.flPermiteMultiplos"
                >
                  Permite Múltiplos
                </b-form-checkbox>
              </default-form-validation-provider>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="closeModal"
          >Cancelar</b-button
        >
        <b-button
          size="sm"
          variant="secondary"
          :disabled="!form.dsTipoAnexo || !form.tpGrupoAnexo || tiposEditalSelected.length === 0 || dtVigenciaInvalida || busy"
          @click="handleSubmit(salvar)"
        >
          {{ isEdicao ? "Editar" : "Adicionar" }}
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { SelectValue } from "@/types/select-value";
import { ValidationObserver } from "vee-validate";
import { TipoAnexo } from "@/types/atos-pessoal/concursos/tipo-anexo";
import { TipoAnexoForm } from "@/types/atos-pessoal/concursos/tipo-anexo-form";
import { Component, Prop, Vue } from "vue-property-decorator";
import concursoService from "@/services/atos-pessoal/concursoService";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

@Component({
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
  },
})
export default class ModalTipoAnexo extends mixins(UtilsTS, Vue) {
  @Prop({ default: null }) item!: TipoAnexo | null;

  modalAberto = true;
  busy = false;
  form = new TipoAnexoForm(this.item ?? undefined);
  tiposEditalSelected: string[] = this.item?.DsTipoEdital?.split(';').filter(Boolean) ?? [];

  gruposSelect: SelectValue[] = [
    { value: "", text: "Selecione o grupo" },
    { value: "CAD", text: "Cadastro" },
    { value: "HML", text: "Homologação" },
    { value: "PUB", text: "Publicidade" },
    { value: "PRO", text: "Prorrogação" },
    { value: "CAN", text: "Cancelamento" },
  ];

  get isEdicao(): boolean {
    return this.form.idTipoAnexo > 0;
  }

  get title(): string {
    return this.isEdicao ? "Editar Tipo de Anexo" : "Adicionar Tipo de Anexo";
  }

  get dtVigenciaInvalida(): boolean {
    const { dtInicioVigencia, dtFimVigencia } = this.form;
    if (!dtInicioVigencia || !dtFimVigencia) return false;
    return dtFimVigencia <= dtInicioVigencia;
  }

  async salvar(): Promise<void> {
    try {
      this.busy = true;
      this.form.dsTipoEdital = this.tiposEditalSelected.join(';');
      if (this.isEdicao) {
        await concursoService.alterarTipoAnexo(
          this.form.idTipoAnexo,
          this.form.toEnvio()
        );
        this.$toast.success("Tipo de Anexo editado com sucesso");
      } else {
        await concursoService.adicionarTipoAnexo(this.form.toEnvio());
        this.$toast.success("Tipo de Anexo adicionado com sucesso");
      }
      this.$emit("salvo");
      this.closeModal();
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      this.busy = false;
    }
  }

  closeModal(): void {
    this.$emit("close");
  }
}
</script>
